/* eslint-disable */
const regex = {
  //   alphaNumeric: /^[a-zA-Z0-9]*$/
  alphaNumeric: /^[a-zA-Z0-9]+$/,
  alphaNumericWithSpace: /^[a-zA-Z0-9 ]+$/,
  numeric: /^[0-9]*$/,
  indianCurrency: /\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g,
  numericNotZero: /^[1-9][0-9]*$/,
  loanAcNo: /^[a-zA-Z0-9]+$/,
  alphabet: /^[a-zA-Z.]+$/,
  alphabetWithSpace: /^[a-zA-Z ]+$/,
  specialCharacter: /^(?!.*\s\s)[a-zA-Z0-9][a-zA-Z0-9.,#-]*(?:\s[a-zA-Z0-9.,#-]+?)*$/,
  address: /^(?!.*\s\s)[a-zA-Z0-9][a-zA-Z0-9._,-/#:;]*(?:\s[a-zA-Z0-9_.,-/#:;]+?)*$/,
  // address1: /^(?!.*\s{2})[a-zA-Z0-9_,\s\-/#:;()]*[a-zA-Z0-9]$/,
  address1:
    /^(?!.*\s\s)[a-zA-Z0-9_,\-/#:;()][a-zA-Z0-9._,\-/#:;()]*?(?:\s[a-zA-Z0-9._,\-/#:;()]+?)*$/,
  nomineefullNamewithDot: /^(?!.*\s{2})(?!.*\.{2})(?!\s)(?!\.)[A-Za-z\s]*\.?[A-Za-z\s.]*[A-Za-z]$/,
  fullNamewithDot: /^(?!.* {2})(?!.*\.{2})[A-Za-z][A-Za-z.]*[A-Za-z]$/,
  fullNamewithDotFix: /^(?!.* {2})(?!.*\.{2})[A-Za-z.]*[A-Za-z]$/,
  fullNamewithDotFixSpace: /^(?!.* {2})(?!.*\.{2})[A-Za-z. ]*[A-Za-z]$/,
  fullName: /^[A-Za-z][A-Za-z]*((\s[A-Za-z]+)*)$/,
  alphaNumericWithRestriction: /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/,
  nameOfOrganizationRestriction:
    /^(?!.*\s\s)[a-zA-Z0-9][a-zA-Z0-9.,:;&"]*(?:\s[a-zA-Z0-9.,:;&"]+?)*$/,
  //   notEmptyString: /^[^\s]+(\s{1}[^\s]+)*$/,
  //   city: /^[a-zA-Z]+(?:[\s-&][a-zA-Z]+)*$/,
  //   time: /^(1[012]|0[1-9]):[0-5][0-9]\s?(am|pm|AM|PM)$/,
  pincode: /^\d{6}$/,
  oneToTwelveRange: /^(?:[1-9]|1[0-2])$/,
  //   fullName: /^[a-zA-Z]+(?: +[a-zA-z]+){1,2}$/,
  //   vehicleModel: /^(?!.*?\.\.)[a-zA-Z](.*[a-zA-Z.&])?$/,
  // Individual Name Regex For Endorsement
  //   name: /^(?!.*?\.\.)[a-zA-Z](.*[a-zA-Z.])?$/,
  //   alphaNumericWithSpace: /^[a-zA-Z0-9\s]+$/,
  //   memberId: /^[A-Za-z0-9\\/().]*$/,
  digitsUpto2Precision: /^\d+(\.\d{1,2})?$/,
  SevenDigitsUpto2Precision: /^\d{1,7}(\.\d{1,2})?$/,
  tenDigitsUpto2Precision: /^\d{1,10}(\.\d{1,2})?$/,
  tenDigitsUpto2PrecisionWithoutZero: /^[1-9]\d{0,9}(\.\d{1,2})?$$/,
  digitThreeDigitbeforeDecimal: /^\d{1,3}(\.\d{1,2})?$/,
  digits: /^[0-9]*$/,
  //   location: /^[a-zA-Z0-9][a-zA-Z0-9., ]*$/,
  //   vehicleNumber: /^[A-Z]{2} [0-9]{1,2} [A-Z]{1,3} [0-9]{4}$/,
  //   gstno: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}\d{1}$/,
  //   income: /^[0-9]{1,10}$/,
  pancard: /^[a-zA-Z]{5}\d{4}[a-zA-Z]{1}$/,
  //   passport: /^[A-Z]{1}[0-9]{7}$/,
  email:
    /^(?!.*\s)[A-Za-z0-9]+(?:[._%-][A-Za-z0-9]+)*@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}(?!\s)$/,
  // email:
  //   /^(?!.*\s)[A-Za-z0-9]+(?:[._%-](?![._%-]))*[A-Za-z0-9]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+(?!.*\.\.))*\.[A-Za-z]{2,}(?!\s)$/,
  //   landLineNo: /^[0-9]{10,15}$/,
  //   singleName: /^[A-Za-z]+$/,
  mobileNumber: /^[6-9][0-9]{9}$/,
  //   chasisNumber: /^[a-zA-Z0-9~/\s]+$/,
  //   awbNumber: /^[a-zA-Z0-9_@!%'/:;,]*$/,
  //   remarks: /^(?=.*[^\s])[a-zA-Z0-9\s,.-]+$/,
  digitsUpto2PrecisionLessThan100: /^(100|[1-9]?\d(\.\d{1,2})?)$/,
  digitsOneToHundred: /^(100|0|[1-9][0-9]?)$/,
  digitsOneToNine: /^[0-9]$/,
  digitsOneToFive: /^[0-5]$/,
  withoutSpaceRegex: /^(?!.*  )[A-Za-z ]+$/,
  numberWithoutPreceedingZero: /^(0|[1-9][0-9]{0,1})$/,
  FirstCharCapital: /(^\s*\w|[\.\!\?]\s*\w)/g,
  withoutSpaceAlphnumeric: /^(?!.* )[A-Za-z0-9]+$/,
  digitsWithTwoPrecisionWithoutPrecidingZero: /^(?!0\d)\d+(\.\d{1,2})?$/,
  digitfifteenDigitbeforeDecimal: /^\d{1,15}(\.\d{1,2})?$/,
  alphaNumericWithoutConsecutiveSpace: /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/,
  loanIntersetRate: /^(8(\.\d{1,2})?|9(\.\d{1,2})?|10(\.\d{1,2})?|11(\.\d{1,2})?|12(\.0{1,2})?)$/,
  loanInterestRateFormat: /^\d+(?:\.0|\.5)?$/,
  loanAmountRegex: /^(?:[3-9]\d{5}|[1-9]\d{6,7}|10{1}0{7})$/,
  alphabetWithFullStop: /^[A-Za-z. ]+$/,
  alphanumericWithSpecialCharacters: /^(?! )[a-zA-Z0-9.,\/()\-_\@&]*(?: [a-zA-Z0-9.,\/()\-_\@&]+)*$/
};

export default regex;
